export default "__VITE_ASSET__Brwb2Mxv__"